module.exports = __webpack_public_path__ + "img/fanfengbo.df123d65.jpg";